/**
 * Shell configuration for the qx-lunarheart site (replacement for wordpress.qiksolve.com).
 * Consumed by layouts/default.vue for navigation and footer content.
 */
interface MenuItem {
  label: string;
  route: string;
  external?: boolean;
}

export default defineAppConfig({
  ui: {
    colors: {
      primary: 'brand',
      neutral: 'slate',
    },
  },
  shellConfig: {
    logo: {
      src: '/images/qiksolve_logo.webp',
      alt: 'QikSolve',
      iconSrc: '/images/qiksolve_logo.webp',
    },
    navigationMenu: [
      { label: 'Explore by Need', route: '/explore-by-need' },
      { label: 'Products', route: '/products' },
      { label: 'Services', route: '/services/' },
      { label: 'Industries', route: '/industries' },
      { label: 'Insights', route: '/blog' },
      { label: 'About Us', route: '/about' },
    ] satisfies MenuItem[],
    footer: {
      copyrightYear: new Date().getFullYear(),
      companyName: 'QikSolve',
      links: [
        { label: 'Privacy', route: '/privacy', external: false },
      ],
    },
  },
});
